<template>
    <div class="app">
        <Sidebar
            v-if="!hideUI"
            :minimized="minimized"
        />
        <DWrapper>
            <Header
                v-if="!hideUI && breadcrumbs.length > 0"
                :breadcrumbs="breadcrumbs"
            />

            <main class="d-main">
                <DBreadcrumbs
                    v-if="!hideUI"
                    :breadcrumbs="breadcrumbs"
                />

                <slot />
            </main>
            <DToaster
                v-if="$page.props.flash.message"
                placement="top-end"
                visible
            >
                <DToast
                    :key="'flash'"
                    color="success"
                    :visible="true"
                    header-text="Success"
                    :body-text="$page.props.flash.message"
                />
            </DToaster>
            <DToaster
                v-if="$page.props.flash.errorMessage"
                placement="top-end"
                visible
            >
                <DToast
                    :key="'flash'"
                    color="danger"
                    :visible="true"
                    header-text="Error"
                    :body-text="$page.props.flash.errorMessage"
                />
            </DToaster>
            <DToaster
                v-if="$page.props.flash.warningMessage"
                placement="top-end"
                visible
            >
                <DToast
                    :key="'flash'"
                    color="warning"
                    :autohide="false"
                    :visible="true"
                    header-text="Warnung"
                    :body-text="$page.props.flash.warningMessage"
                />
            </DToaster>
        </DWrapper>
    </div>
</template>

<script>
import Sidebar from './Components/App/Sidebar/Sidebar'
import Header from './Components/App/Header'
import DBreadcrumbs from '~@/Components/App/Header/DBreadcrumbs'
import { router, usePage } from '@inertiajs/vue3'
import { buildBreadcrumbs } from './Configurations/sitemap'
import sitemap from './Configurations/sitemap/sitemap'
import DWrapper from './Components/Common/DWrapper.vue'

const timeoutTime = 5000

export default {
    name: 'App',
    components: {
        DWrapper,
        Sidebar,
        Header,
        DBreadcrumbs
    },
    data () {
        return {
            minimized: false,
            hideUI: true,
            breadcrumbs: []
        }
    },
    computed: {
        page () {
            return usePage()
        }
    },
    watch: {
        'page.props.flash.message': {
            handler () {
                if (this.page.props.flash.message) {
                    setTimeout(function (scope) {
                        scope.page.props.flash.message = null
                    }, timeoutTime, this)
                } else {
                    this.page.props.flash.message = null
                }
            }
        },
        'page.props.flash.errorMessage': {
            handler () {
                if (this.page.props.flash.errorMessage) {
                    setTimeout(function (scope) {
                        scope.page.props.flash.errorMessage = null
                    }, timeoutTime, this)
                } else {
                    this.page.props.flash.errorMessage = null
                }
            }
        },
        '$page.props.flash.warningMessage': {
            handler () {
                if (!this.$page.props.flash.warningMessage) {
                    this.$page.props.flash.warningMessage = null
                }
            }
        }
    },
    mounted () {
        this.emitter.on('sidebar-toggle', () => {
            this.$data.minimized = !this.$data.minimized
        })

        this.updateBreadcrumbs()
        router.on('navigate', (event) => {
            this.hideUI = ['login'].includes(this.$route().current())
            this.updateBreadcrumbs()
        })
    },

    methods: {
        updateBreadcrumbs () {
            const fullBreadcrumbs = []

            const breadcrumbs = buildBreadcrumbs(sitemap(this.$t), this.$route().current(), this.$route().params)

            if (breadcrumbs !== null) {
                breadcrumbs.forEach(item => {
                    let currentRouteParameters = this.$route().params

                    // Check if object empty
                    if (Object.keys(item.href.params).length !== 0) {
                        for (const currentParam in currentRouteParameters) {
                            // Delete unnecessary params
                            if (!item.href.params.includes(currentParam)) {
                                delete currentRouteParameters[currentParam]
                            }
                        }
                    } else {
                        currentRouteParameters = item.href.params
                    }

                    fullBreadcrumbs.push({
                        text: item.text,
                        href: item.href.route !== '' ? this.$route(item.href.route, currentRouteParameters) : ''
                    })
                }, this)
            }

            // Mark sidebar item as active
            this.emitter.emit('select-sidebar')

            this.breadcrumbs = fullBreadcrumbs
            const translationKey = fullBreadcrumbs.length > 0 ? fullBreadcrumbs.map(x => x.text).join(' / ') : ''
            document.title = translationKey + ' - Dogado SSL tool'
        }
    }
}
</script>

<style lang="scss" scoped>
    .app {
        width: 100vw;
        height: 100vh;
        overflow-x: hidden;
        display: grid;
        grid-template-rows: auto 1fr;

        & .d-main-wrapper {
            display: grid;
            grid-template-rows: auto 1fr;
            overflow: hidden;

            & .d-main {
                overflow-y:scroll;
                height: 100%;
                padding-bottom: 80px;
            }
        }
    }
</style>
